import React from "react";
import HeroFour from "./HeroFour";
import MeetDeepak from "./MeetDeepak";
import InjkWater from "./InjkWater";
import ReWater from "./ReWater";
import HowItWork from "./HowItWork";
import WaterHold from "./WaterHold";
import Callaborate from "./Callaborate";
import Testimonials from "../home/testimonials/Testimonials";
import Icons from "../common/components/Icons";
import Roadmap from "./Roadmap";

const Inventors = () => {
  return (
    <>
      <HeroFour />
      <Roadmap />
      <MeetDeepak />
      <InjkWater />
      <ReWater />
      <HowItWork />
      <WaterHold />
      <Testimonials
        badge="Testimonials"
        title="Testimonials & Results"
        description={
          <span className=" flex gap-x-4 sm:gap-x-8 lg:gap-x-10 items-center justify-center lg:pt-1">
            <span className="flex items-center gap-x-1 sm:gap-x-1.5">
              <Icons icon="blue-check" />{" "}
              <span className="font-semibold text-sm text-custom-dark-blue">
                {" "}
                Focus
              </span>
            </span>
            <span className="flex items-center gap-x-1 sm:gap-x-1.5">
              <Icons icon="blue-check" />{" "}
              <span className="font-semibold text-sm text-custom-dark-blue">
                {" "}
                Peace
              </span>
            </span>
            <span className="flex items-center gap-x-1 sm:gap-x-1.5">
              <Icons icon="blue-check" />{" "}
              <span className="font-semibold text-sm text-custom-dark-blue">
                {" "}
                Wealth
              </span>
            </span>
          </span>
        }
      />
      <Callaborate />
    </>
  );
};

export default Inventors;
